let { countCharacters } = require('./utf8.js');

function processTexts(texts) {
  texts = texts = texts.filter(t => Boolean(t) && typeof t === 'string');
  // special characters decoding
  for (let t = 0; t < texts.length; t++) {
    texts[t] = texts[t].replace(/&#(\d+);/g, function (m, n) {
      return String.fromCharCode(n);
    });
  }
  return texts
    .filter(text => text)
    .map(text => {
      text = text.replace(/official website/gi, '');
      text = text.replace(/(\n|\t)/g, '');
      if (text === 'null') text = '';
      // text = text.replace("홈페이지", "")
      return text;
    });
}

const sentenceLimitRegexp = /([\?\!]+)|\.$|\.[ \n\r]|(?:[\n]|\:[ \n\r]|[\-\–\|][ \n\r]|[ \n\r\u00a0]{4,})/g;
const sentenceLimitRegexp2 = /([\?\!]+|\.$|\.[ \n\r]|[\n]|\:[ \n\r]|[\-\–\|][ \n\r]|[ \n\r\u00a0]{4,})/g;

function selectText(texts, { idealLength = 90, maxLength, doPreprocess = true } = {}) {
  texts = texts = texts.filter(t => Boolean(t) && typeof t === 'string');
  texts = texts.map(sanitizeEmoji);
  if (doPreprocess) texts = processTexts(texts);
  let bestScore = -Infinity;
  let bestText = undefined;
  for (let text of texts) {
    let score = 100;
    if (!text) continue;
    if (text.toLowerCase().includes('official website')) {
      score -= 50;
    }
    if (maxLength && text.length > maxLength) {
      score -= 40;
      var rawSentences = text.split(sentenceLimitRegexp2);
      var shorterText = '';
      for (let r = 0; r < rawSentences.length; r++) {
        let rawSentence = rawSentences[r];
        let isTooLong = shorterText.length + rawSentence.length > maxLength;
        if (isTooLong) {
          if (shorterText) {
            text = shorterText.replace(/([\.\-\!\?\:])[\.\-\!\?\: \r\n]*$/, (x, y) => y);
          } else {
            score -= 20;
            text = text.substring(0, maxLength - 1);
            if (text[text.length - 1] == '\ud83d') {
              text = text.substring(0, text.length - 1);
            }
            text += '…';
          }
          break;
        }
        shorterText += rawSentence;
      }
    }
    score -= Math.abs(countCharacters(text) / idealLength - 1);
    if (score > bestScore) {
      bestScore = score;
      bestText = text;
    }
  }
  return bestText;
}

function cutText(texts, { maxPart = 4, maxLength = 25 } = {}) {
  texts = texts.filter(t => Boolean(t) && typeof t === 'string');
  texts = processTexts(texts);
  let bestScore = -Infinity;
  let bestSentences = [];
  for (let text of texts) {
    let score = 100;
    if (!text) continue;
    var rawSentences = text.split(sentenceLimitRegexp);
    let sentences = [];
    for (let s = 0; s < rawSentences.length; s += 2) {
      let sentence = rawSentences[s];
      if (rawSentences[s + 1]) sentence += rawSentences[s + 1];
      sentence = sentence.trim();
      if (sentence) sentences.push(sentence);
    }
    while (sentences.length > maxPart) {
      let { ind } = argmin(sentences, s => countCharacters(s));
      let mergeInd;
      if (ind == 0) {
        mergeInd = ind;
      } else if (ind == sentences.length - 1) {
        mergeInd = ind - 1;
      } else {
        if (countCharacters(sentences[ind - 1]) < countCharacters(sentences[ind + 1])) mergeInd = ind - 1;
        else mergeInd = ind;
      }
      let dot = /[\.\?\!]$/.test(sentences[mergeInd]) ? '' : '.';
      let newSentence = sentences[mergeInd] + dot + ' ' + sentences[mergeInd + 1];
      if (countCharacters(newSentence) < maxLength) sentences.splice(mergeInd, 2, newSentence);
      else break;
    }
    // let sentences = rawSentences.map(s=>s.replace(/[\.\!\|\-]+$/g, '').trim())
    if (sentences.length > maxPart) {
      score -= 20;
      sentences = sentences.slice(0, maxPart);
    }
    for (let s = 0; s < sentences.length; s++) {
      let sentence = sentences[s];
      if (countCharacters(sentence) > maxLength) {
        score -= 10;
        while (countCharacters(sentence) > maxLength - 1) sentence = sentence.substring(0, sentence.length - 1);
        if (sentence[sentence.length - 1] == '\ud83d') {
          sentence = sentence.substring(0, sentence.length - 1);
        }
        sentences[s] = sentence + '…';
      } else {
        score += countCharacters(sentence) / maxLength;
      }
    }
    if (score > bestScore) {
      bestScore = score;
      bestSentences = sentences;
    }
  }
  return bestSentences;
}

function argmin(list, scoreFunction) {
  let bestScore = Infinity,
    bestEl,
    bestInd;
  for (let ind = 0; ind < list.length; ind++) {
    let el = list[ind];
    let score = scoreFunction ? scoreFunction(el) : el;
    if (score < bestScore) {
      bestScore = score;
      bestEl = el;
      bestInd = ind;
    }
  }
  return { ind: bestInd, el: bestEl, score: bestScore };
}

function convertTextFromFacebookToGoogle(facebookTitle, facebookDescription) {
  return {
    title: cutText([facebookTitle], { maxPart: 3, maxLength: 30 }),
    description: cutText([facebookDescription], { maxPart: 2, maxLength: 90 }),
  };
}

const sanitizeEmoji = (str = '') =>
  str.replace(
    /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/gim,
    '',
  );

module.exports = { cutText, selectText, sanitizeEmoji, convertTextFromFacebookToGoogle };
